import { render, staticRenderFns } from "./GenerationHistoryFavoritesListView.vue?vue&type=template&id=05b6aff6"
import script from "./GenerationHistoryFavoritesListView.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryFavoritesListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports